import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Warehouse;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Warehouse.Phaser.IntroductionScene.1",
            "Warehouse.Phaser.IntroductionScene.2",
            "Warehouse.Phaser.IntroductionScene.3",
            "Warehouse.Phaser.IntroductionScene.4",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/WarehouseGame/scenes/GameIntro.ts